export enum BillingOperation {
    REPLACE_INVOICE_REPORTS = 'operation.module.billing.replace-invoice-reports',
    REPLACE_INVOICE_PAYMENTS_REPORTS = 'operation.module.billing.replace-invoice-payment-reports',
    MANAGE_APPLIED_CONCEPTS = 'operation.module.billing.manage-applied-concepts',
    MANAGE_DELIVERY_NOTES = 'operation.module.billing.manage-delivery-notes',
    MANAGE_INVOICES = 'operation.module.billing.manage-invoices',
    MANAGE_INVOICE_PAYMENTS = 'operation.module.billing.manage-invoice-payments',
    MANAGE_INVOICE_RECEIPTS = 'operation.module.billing.manage-invoice-receipts',
    BILLABLE_CONCEPTS_AND_CASES_ACCESS = 'operation.module.billing.billable-concepts-and-cases-access',
    DELIVERY_NOTES_ACCESS = 'operation.module.billing.delivery-notes-access',
    BILLING_INVOICES_ACCESS = 'operation.module.billing.billing-invoices-access',
    BILLING_RECEIPTS_ACCESS = 'operation.module.billing.billing-receipts-access',
    BILLING_PAYMENTS_ACCESS = 'operation.module.billing.billing-payments-access'
}
